import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IFoThucDonActionTypes } from "../../action-types/thuc-don/IFoThucDonActionTypes";
import { IFoThucDonReducer } from "../../page-state-model/thuc-don/IFoThucDonReducer";
const iniState: IFoThucDonReducer = {
    status: ePageBaseStatus.is_not_initialization,
    foThucDons: [],
    foThucDonTheoNgays: [],
    foThucDonVms: []
}
export const foThucDonReducer = (state: IFoThucDonReducer = iniState, action: IFoThucDonActionTypes): IFoThucDonReducer => {
    switch (action.type) {
        case "THUC_DON_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "THUC_DON_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foThucDons: action.payload
            }
        case "THUC_DON_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foThucDons: []
            }
        case "THUC_DON_LOAD_COSO_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "THUC_DON_LOAD_COSO_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foThucDonVms: action.payload
            }
        case "THUC_DON_LOAD_COSO_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foThucDonVms: []
            }
        case "THUC_DON_LOAD_THEO_NGAY_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "THUC_DON_LOAD_THEO_NGAY_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foThucDonTheoNgays: action.payload
            }
        case "THUC_DON_LOAD_THEO_NGAY_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foThucDonTheoNgays: []
            }
        case "THUC_DON_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "THUC_DON_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "THUC_DON_SHOW_IMPORT_MODAL":
            return {
                ...state,
                isShowImportModal: true
            }
        case "THUC_DON_CLOSE_IMPORT_MODAL":
            return {
                ...state,
                isShowImportModal: false,
            }
        case "THUC_DON_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "THUC_DON_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "THUC_DON_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "THUC_DON_INSERT_MULTIPLE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "THUC_DON_INSERT_MULTIPLE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload
            }
        case "THUC_DON_INSERT_MULTIPLE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "THUC_DON_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "THUC_DON_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "THUC_DON_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}